module.exports = __webpack_public_path__ + "static/media/YB5F17_2.153ec6a3.jpg";